export default class formConfig {
  // 招标计划
  static configList() {
    return [
      {
        title: "监管流程",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "流程种类：",
            value: "processClass",
            type: "radio",
            required: true,
            option: [
              {
                label: "监管流程",
                value: "0"
              },
              {
                label: "工作人员流程",
                value: "1"
              }
            ],
            rule: {
              required: true,
              message: "请选择流程种类",
              trigger: "blur"
            },
          },
          {
            label: "流程类型：",
            type: "select",
            value: "processType",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201510311952300005",
            },
            rule: {
              required: true,
              message: "请选择流程类型",
              trigger: "blur"
            },
          },
          {
            label: "管理部门：",
            type: "select",
            value: "competentDepart",
            placeholder: "请输入",
            queryParams: {
              url: "/zoneDepartment/DepartmentCombobox",
            },
            rule: {
              required: false,
              message: "请选择管理部门",
              trigger: "blur"
            },
          },
          {
            label: "流程区分：",
            value: "processDistinguish",
            type: "radio",
            required: true,
            option: [
              {
                label: "平台核验",
                value: "01"
              },
              {
                label: "招标监管",
                value: "02"
              }
            ],
            rule: {
              required: true,
              message: "请选择流程区分",
              trigger: "blur"
            },
          },
          {
            label: "操作指南：",
            type: "select",
            value: "operatorGuide",
            placeholder: "请输入",
            queryParams: {
              url: '/dataDictionaryEntries/Combobox',
              table: 'V2_INTERIOR_CMS_',
              value: 'ID_',
              name: 'XXBT_',
              where: "AND XXLX_ = '201407161546050010'"
            },
            rule: {
              required: false,
              message: "请选择操作指南",
              trigger: "blur"
            },
          },
        ]
      },
      {
        title: "监管流程节点",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "nodeList",
            class: "formList",
          },
        ]
      },
      {
        title: "备注",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "备注：",
            value: "description",
            type: "textarea",
            required: true,
            maxlength: 450,
            minRows: "3",
            maxRows: "2",
            width: "100%;",
            rule: {
              required: false,
              message: "请填写备注",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
}
